import { render, staticRenderFns } from "./droppable.vue?vue&type=template&id=15a8fedb&"
import script from "./droppable.vue?vue&type=script&lang=js&"
export * from "./droppable.vue?vue&type=script&lang=js&"
import style0 from "./droppable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports